import { forwardRef, ForwardRefExoticComponent } from 'react'
import { NavLink, NavLinkProps } from 'react-router-dom'

export const MyLink: ForwardRefExoticComponent<NavLinkProps> = forwardRef((props, _) => {
  if (props?.target === '_blank')
    return <a {...{ ...props, href: (props?.to as string) ?? '#', download: `${props?.title}.docx` }}>{props?.title}</a>

  return <NavLink exact activeClassName="active" {...props} />
})
